import { Button } from "antd";
import "antd/dist/antd.css";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { apigetCredit } from "../../services/apis/profile";
import { numberWithCommas } from "../../untills/function";
import "./Navbar.css";

const Navbar = () => {
  const history = useHistory();
  const [credit, setCredit] = useState(
    localStorage.getItem("rondori_credit") || 0
  );

  useEffect(() => {
    let intime1 = setInterval(() => {
      let token = localStorage.getItem("rondori_token");
      if (token) getCreditUser();
    }, 3000);

    return () => clearInterval(intime1);
  }, []);

  const getCreditUser = async () => {
    const creditUser = await apigetCredit();
    if (creditUser && creditUser.status) {
      setCredit(creditUser.result);
      localStorage.setItem("rondori_credit", creditUser.result);
    }
  };

  return (
    <div className="cov-bar">
      <div className="nav-app">
        <div className="nav-header-bg" />
        <div className="app-top-bar">
          <div className="app-ron">RONDORI</div>
          <div className="credit-total">
            {localStorage.getItem("rondori_token") ? (
              "฿ " + numberWithCommas(credit, 0)
            ) : (
              <Button className="btn-login" onClick={() => history.push("/")}>
                เข้าสู่ระบบ
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
